import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { apiGetConnectedApps } from "../services/OAuthService";
import { setConnectedApps } from "../redux/features/connectedApps/connectedAppsSlice";
import { selectUser } from "../redux/features/appData";

export const useConnectedAppRefresh = () => {
  const dispatch = useDispatch();
  const userId = useSelector(selectUser)?.id;

  const refresh = async (connApps?: []) => {
    if (userId && !connApps) {
      const result = await apiGetConnectedApps(userId);
      dispatch(setConnectedApps(result));
    } else {
      dispatch(setConnectedApps(connApps || []));
    }
  };

  return { refresh };
};
